// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__F6kUm","content":"styles_content___znC_"};